import { TranslationKey } from "types";

export enum IndustryType {
  All = "All Industries",
  Education = "Education",
  Hospitality = "Hospitality",
  EnterpriseOffice = "Enterprise Office",
  Retail = "Retail",
  MissionCritical = "Mission Critical",
}

export interface Customers {
  industryType: IndustryType;
  name: string;
  logo: string;
}

export interface IIndustryTypeItem {
  index: number;
  id: IndustryType;
  value: IndustryType;
  label: TranslationKey;
}
